import {
  ADD_UPDATE_INVOICE_ML_ENTRY_FAILURE,
  ADD_UPDATE_INVOICE_ML_ENTRY_REQUEST,
  ADD_UPDATE_INVOICE_ML_ENTRY_SUCCESS,
  DOWNLOAD_INVOICE_FILE_FAILURE,
  DOWNLOAD_INVOICE_FILE_REQUEST,
  DOWNLOAD_INVOICE_FILE_SUCCESS,
  FETCH_INVOICE_LIST_FAILURE,
  FETCH_INVOICE_LIST_REQUEST,
  FETCH_INVOICE_LIST_SUCCESS,
  GET_INVOICE_DETAILS_BY_ID_FAILURE,
  GET_INVOICE_DETAILS_BY_ID_REQUEST,
  GET_INVOICE_DETAILS_BY_ID_SUCCESS,
} from "./actionTypes";

export const fetchInvoiceListRequest = (url: string, payload: any) => ({
  type: FETCH_INVOICE_LIST_REQUEST,
  url,
  payload,
});

export const fetchInvoiceListSuccess = (payload: any) => ({
  type: FETCH_INVOICE_LIST_SUCCESS,
  payload: payload,
});

export const fetchInvoiceListFailure = (payload: any) => ({
  type: FETCH_INVOICE_LIST_FAILURE,
  payload: payload,
});

export const downloadInvoiceFileRequest = (
  url: any,
  payload: any,
  callback: unknown
) => ({
  type: DOWNLOAD_INVOICE_FILE_REQUEST,
  url,
  payload,
  callback,
});

export const downloadInvoiceFileSuccess = (payload: any) => ({
  type: DOWNLOAD_INVOICE_FILE_SUCCESS,
  payload: payload,
});

export const downloadInvoiceFileFailure = (payload: any) => ({
  type: DOWNLOAD_INVOICE_FILE_FAILURE,
  payload: payload,
});

export const fetchInvoiceDetailsByIDRequest = (
  url: string,
  callback: unknown
) => ({
  type: GET_INVOICE_DETAILS_BY_ID_REQUEST,
  url,
  callback,
});

export const fetchInvoiceDetailsByIDSuccess = (payload: any) => ({
  type: GET_INVOICE_DETAILS_BY_ID_SUCCESS,
  payload: payload,
});

export const fetchInvoiceDetailsByIDFailure = (payload: any) => ({
  type: GET_INVOICE_DETAILS_BY_ID_FAILURE,
  payload: payload,
});

export const addUpdateInvoiceMLEntryRequest = (
  url: string,
  payload: any,
  callback: unknown
) => ({
  type: ADD_UPDATE_INVOICE_ML_ENTRY_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateInvoiceMLEntrySuccess = (successMessage: string) => ({
  type: ADD_UPDATE_INVOICE_ML_ENTRY_SUCCESS,
  payload: { successMessage },
});

export const addUpdateInvoiceMLEntryFailure = (error: string) => ({
  type: ADD_UPDATE_INVOICE_ML_ENTRY_FAILURE,
  payload: error,
});